import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { db } from '../firebase';
import { collection, query, where, getDocs } from 'firebase/firestore';

function aFecha(valor) {
  if (!valor) return null;
  const d = valor.toDate ? valor.toDate() : new Date(valor);
  return isNaN(d.getTime()) ? null : d;
}

/**
 * Aviso compacto "Próximos remates" para el Home.
 * Es una sola línea clickeable que lleva a /remates.
 * No renderiza nada si no hay remates futuros publicados.
 */
export default function FranjaRemates() {
  const [cantidad, setCantidad] = useState(0);

  useEffect(() => {
    async function cargar() {
      try {
        const desde = new Date();
        desde.setHours(desde.getHours() - 12);
        const snap = await getDocs(query(collection(db, 'remates'), where('publicada', '==', true)));
        const futuros = snap.docs.filter(d => { const data = d.data(); if (data.eliminado) return false; const f = aFecha(data.fechaHora); return f && f >= desde; });
        setCantidad(futuros.length);
      } catch (err) {
        console.error('Error cargando aviso de remates:', err);
      }
    }
    cargar();
  }, []);

  if (cantidad === 0) return null;

  const texto = cantidad === 1 ? 'Hay 1 próximo remate' : `Hay ${cantidad} próximos remates`;

  return (
    <Link to="/remates" style={{ textDecoration: 'none', display: 'block' }}>
      <div
        style={{ background: '#0d1b2a', color: 'white', padding: '11px 20px', textAlign: 'center', fontSize: '14px', fontWeight: 600, transition: 'background 0.15s' }}
        onMouseEnter={e => { e.currentTarget.style.background = '#13263b'; }}
        onMouseLeave={e => { e.currentTarget.style.background = '#0d1b2a'; }}
      >
        🔨 {texto} — <span style={{ color: '#7dd3fc' }}>Ver agenda →</span>
      </div>
    </Link>
  );
}
